import clsx from 'clsx';
import {
  Avatar,
  ChannelPreviewUIComponentProps,
  useChatContext,
} from 'stream-chat-react';

import { StreamChatType } from '../../types';
import { getUnreadLabel } from './utils';

type DirectMessagingChannelPreviewProps = Pick<
  ChannelPreviewUIComponentProps<StreamChatType>,
  'channel'
> & {
  unreadCount?: number;
};

export const DirectMessagingChannelPreview = ({
  channel,
  unreadCount,
}: DirectMessagingChannelPreviewProps) => {
  const { client } = useChatContext<StreamChatType>();
  const unreadLabel = getUnreadLabel(unreadCount);

  const members = Object.values(channel.state.members).filter(
    ({ user }) => user?.id !== client.userID
  );
  const defaultName = 'Johnny Blaze';

  if (!members.length || members.length === 1) {
    const member = members[0];
    return (
      <div
        className={clsx('channel-preview__item', 'single', {
          bold: !!unreadLabel,
        })}
      >
        <Avatar
          image={member.user?.image}
          name={member.user?.name || member.user?.id}
          size={24}
        />
        <p>{member?.user?.name || member?.user?.id || defaultName}</p>
        {unreadLabel && (
          <span className="channel-preview__unread-count">{unreadLabel}</span>
        )}
      </div>
    );
  }

  return (
    <div
      className={clsx('channel-preview__item', 'multi', {
        bold: !!unreadLabel,
      })}
    >
      <span>
        <Avatar
          image={members[0].user?.image}
          name={members[0].user?.name || members[0].user?.id}
          size={18}
        />
      </span>
      <Avatar
        image={members[1].user?.image}
        name={members[1].user?.name || members[1].user?.id}
        size={18}
      />
      <p>
        {members[0].user?.name || members[0].user?.id || defaultName},{' '}
        {members[1].user?.name || members[1].user?.id || defaultName}
      </p>
      {unreadLabel && (
        <span className="channel-preview__unread-count">{unreadLabel}</span>
      )}
    </div>
  );
};
